import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { AdvisorAboutComponent } from "./components/advisor-about/advisor-about.component";
import { AdvisorButtonsComponent } from "./components/advisor-buttons/advisor-buttons.component";
import { AdvisorContactComponent } from "./components/advisor-contact/advisor-contact.component";
import { AdvisorInlineComponent } from "./components/advisor-inline/advisor-inline.component";
import { AdvisorProfileComponent } from "./components/advisor-profile/advisor-profile.component";

@NgModule({
    imports: [CommonModule],
    exports: [AdvisorInlineComponent],
    declarations: [
        AdvisorInlineComponent,
        AdvisorAboutComponent,
        AdvisorProfileComponent,
        AdvisorContactComponent,
        AdvisorButtonsComponent,
    ] 
})
export class AdvisorModule {}